import { Extension } from "@smartsuite/smartdoc";
import { baseKeymap, chainCommands } from "prosemirror-commands";
import { keymap } from "prosemirror-keymap";
import type { Schema } from "prosemirror-model";
import { splitListItem } from "prosemirror-schema-list";
import type { Plugin } from "prosemirror-state";

export class MiniEditorExtension extends Extension {
  addPlugins(schema: Schema, plugins: Plugin[]): Plugin[] {
    return plugins.concat([
      keymap({
        "Shift-Enter": chainCommands(splitListItem(schema.nodes.list_item), baseKeymap.Enter),
        Enter: () => true,
        Escape: () => true,
      }),
    ]);
  }
}
